<template>
  <section class="mh-home image-bg home-2-img" id="home">
    <div class="img-foverlay img-color-overlay">
      <div class="container">
        <div
          class="row section-separator xs-column-reverse vertical-middle-content home-padding"
        >
          <div class="col-sm-6">
            <div class="mh-header-info">
              <div
                class="mh-promo wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.1s"
              >
                <span>Hello I'm</span>
              </div>

              <h2
                class="wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.2s"
                v-text="$store.getters.getAuthor"
              ></h2>
              <h4
                class="wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.3s"
                v-html="$store.getters.getJob"
              ></h4>

              <ul>
                <li
                  class="wow fadeInUp"
                  data-wow-duration="0.8s"
                  data-wow-delay="0.4s"
                >
                  <i class="fa fa-envelope"></i>
                  <a
                    :href="`mailto:${$store.getters.getEmail}`"
                    v-text="$store.getters.getEmail"
                  ></a>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration="0.8s"
                  data-wow-delay="0.5s"
                  v-show="
                    $store.getters.getPhone != '' ||
                    typeof $store.getters.getPhone != 'undefined'
                  "
                >
                  <i class="fa fa-phone"></i>
                  <a
                    :href="`tel:${$store.getters.getPhone}`"
                    v-text="
                      $store.getters.getPhoneStyled != null
                        ? $store.getters.getPhoneStyled
                        : $store.getters.getPhone
                    "
                  ></a>
                </li>
                <li
                  class="wow fadeInUp"
                  data-wow-duration="0.8s"
                  data-wow-delay="0.6s"
                  v-show="
                    $store.getters.getLocation('home') != '' ||
                    typeof $store.getters.getLocation('home') != 'undefined'
                  "
                >
                  <a :href="$store.getters.getLocation('home')" target="_blank">
                    <i class="fa fa-map-marker"></i>
                    <address v-text="$store.getters.getHome"></address>
                  </a>
                </li>
              </ul>

              <ul
                class="social-icon wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.7s"
              >
                <li
                  v-show="
                    $store.getters.getTwitter != '' ||
                    typeof $store.getters.getTwitter == 'undefined'
                  "
                >
                  <a :href="$store.getters.getTwitter" target="_blank">
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>

                <li
                  v-show="
                    $store.getters.getLinkedIn != '' ||
                    typeof $store.getters.getLinkedIn == 'undefined'
                  "
                >
                  <a :href="$store.getters.getLinkedIn" target="_blank">
                    <i class="fa fa-linkedin"></i>
                  </a>
                </li>

                <li
                  v-show="
                    $store.getters.getGithub != '' ||
                    typeof $store.getters.getGithub == 'undefined'
                  "
                >
                  <a :href="$store.getters.getGithub" target="_blank">
                    <i class="fa fa-github"></i>
                  </a>
                </li>

                <li
                  v-show="
                    $store.getters.getFacebook != '' ||
                    typeof $store.getters.getFacebook == 'undefined'
                  "
                >
                  <a :href="$store.getters.getFacebook" target="_blank">
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>

                <li
                  v-show="
                    $store.getters.getDribble != '' ||
                    typeof $store.getters.getDribble == 'undefined'
                  "
                >
                  <a :href="$store.getters.getDribble" target="_blank">
                    <i class="fa fa-dribbble"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-sm-6">
            <div
              class="hero-img wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.6s"
            >
              <div class="img-border">
                <img
                  :src="$store.getters.getProfileImageUrl"
                  :alt="imageAlt"
                  class="img-fluid img-rounded img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    imageAlt() {
      let firstName = this.$store.getters.getFirstName;
      let lastName = this.$store.getters.getLastName;
      return firstName ? `${firstName} ${lastName[0]}.` : firstName;
    },
  },
};
</script>
